import ComercialTable from "@/components/comercial/ComercialTable";
import BackPageButton, {
  backButtonContainer,
} from "@/components/general/buttons/BackPageButton";
import PeregrinClientNavbar from "@/components/general/Navbars/ClientNavbar/PeregrinClientNavbar";
import useFetchUserExcursionFromUserId from "@/hooks/entities/userFetchUserExcursionFromUserId";
import { sharedStyles } from "@/styles/shared";
import { priceFormatter } from "@/utils/priceFormatter";
import { formatDateString } from "@/utils/stringUtils";
import {
  Avatar,
  Box,
  CircularProgress,
  ListItemText,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import excursionDefaultImage from "@/assets/svg/defaultExcursion.svg";
import excursionNotFound from "@/assets/img/excursionNotFound.png";

const ExcursionsHistory = () => {
  const { excursions } = useFetchUserExcursionFromUserId();

  const cartTableHeader = (
    <TableRow>
      <TableCell align="left">Excursão</TableCell>
      <TableCell align="right">Total</TableCell>
    </TableRow>
  );

  const cartTableBody = (
    <>
      {excursions?.map((item, index) => (
        <TableRow
          key={index}
          sx={{
            "&:last-child td, &:last-child th": { border: 0 },
          }}
        >
          <TableCell
            component="th"
            sx={{ ...sharedStyles.horizontalContent }}
            align="left"
          >
            <Avatar
              src={item.imagePreview || excursionDefaultImage}
              sx={sharedStyles.tableAvatarStyle}
            />

            <ListItemText
              primary={`${item.excursionTitle}`}
              secondary={`agente: ${item.excursionAgent}`}
              primaryTypographyProps={{ fontWeight: 500 }}
            />
          </TableCell>

          <TableCell align="right">
            <ListItemText
              primary={`R$ ${priceFormatter(item.totalValue)}`}
              secondary={`${item.quantity} ${item.quantity !== 1 ? " vagas" : "vaga"}`}
              primaryTypographyProps={{ variant: "body2", fontWeight: 500 }}
            />
          </TableCell>
        </TableRow>
      ))}
    </>
  );

  return (
    <Box>
      <PeregrinClientNavbar />

      <Box sx={backButtonContainer}>
        <BackPageButton />
      </Box>

      <Box
        sx={{
          ...sharedStyles.form,
          alignItems: "center",
          justifyContent: "center",
          minHeight: "50vh",
          marginX: { xs: 3, md: 3, lg: 10 },
          marginY: 4,
          gap: 1,
        }}
      >
        {excursions !== null ? (
          <Box width="100%" sx={sharedStyles.verticalContent}>
            {excursions.length > 0 ? (
              <Box width="100%" sx={sharedStyles.verticalContent}>
                <Typography
                  variant="h5"
                  fontWeight="bold"
                  sx={{ alignSelf: "flex-start" }}
                >
                  🧾 Excursões contratadas
                </Typography>

                <ComercialTable header={cartTableHeader} body={cartTableBody} />
              </Box>
            ) : (
              <Box
                width="100%"
                sx={{
                  ...sharedStyles.verticalContent,
                  gap: 0,
                  marginTop: 8,
                  alignItems: "center",
                }}
              >
                <img
                  src={excursionNotFound}
                  alt="Excursion Not Found"
                  style={{ maxWidth: "250px" }}
                />

                <Typography variant="h6" textAlign="center">
                  Nenhuma excursão contratada
                </Typography>
              </Box>
            )}
          </Box>
        ) : (
          <CircularProgress />
        )}
      </Box>
    </Box>
  );
};

export default ExcursionsHistory;
